// Toasts.
//
// Two things differ from the stock shadcn component. `toast` is re-exported
// here because 56 files import it from this module rather than from `sonner`
// directly — that was Retool's convention. And next-themes is not used: the app
// switches theme with a `.dark` class on <html> (see theme.css), so the toaster
// follows the same signal.

import { useEffect, useState } from 'react'
import { Toaster as Sonner, toast } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

function useIsDark(): boolean {
  const [dark, setDark] = useState(
    () => typeof document !== 'undefined' && document.documentElement.classList.contains('dark'),
  )
  useEffect(() => {
    const target = document.documentElement
    const observer = new MutationObserver(() => setDark(target.classList.contains('dark')))
    observer.observe(target, { attributes: true, attributeFilter: ['class'] })
    return () => observer.disconnect()
  }, [])
  return dark
}

function Toaster(props: ToasterProps) {
  const dark = useIsDark()
  return (
    <Sonner
      theme={dark ? 'dark' : 'light'}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
